<template>
  <v-row>
    <v-col>

      <!-- <v-card v-test="{ accounts: BANK_ACCOUNT_TYPES.FEDERAL }">
        <v-toolbar dark color="primary">
          <v-col cols="10">
            <v-toolbar-title class="textwithbackground--text">
              {{ $t('Счета в территориальном органе') }}
            </v-toolbar-title>
          </v-col>
          <v-col class="text-right" cols="2">
            <btn-icon-tip
                v-if="canCreate"
                id="addFederalBankAccountBtn"
                icon="add"
                icon-color="secondaryiconbtn"
                :disabled="innerLoading"
                :tip="$t('Добавить сведения о банковских реквизитах')"
                @click="openAddBankAccountDialog(BANK_ACCOUNT_TYPES.FEDERAL)" />
          </v-col>
        </v-toolbar>
        <v-divider />
        <v-data-table
            :headers="headers1"
            :items="federalAccounts"
            class="elevation-1"
            :items-per-page="itemsPerPage"
            item-key="bankAccountId"
            :no-data-text="$t('Информация не добавлена')"
            :no-results-text="$t('Информация не добавлена')"
            :hide-default-footer="!creditAccounts.length"
            disable-sort-by
            :locale="systemLocale">
          <template v-slot:top>
            <v-progress-linear :active="innerLoading" color="loader" indeterminate />
          </template>
          <template v-slot:item.recipientName="{ item }">
            {{ item.recipientName }}
          </template>
          <template v-slot:item.bankName="{ item }">
            {{ item.bankName }}
          </template>
          <template v-slot:item.personalAccount="{ item }">
            {{ item.personalAccount }}
          </template>
          <template v-slot:item.kbk="{ item }">
            {{ item.kbk }}
          </template>
          <template v-slot:item.oktmo="{ item }">
            {{ item.oktmo }}
          </template>
          <template v-slot:item.isActive="{ item }">
            <btn-icon-tip
                v-if="canEdit"
                :id="`statusBtn-${item.bankAccountId}`"
                icon="fiber_manual_record"
                :icon-color="item.isActive
                  ?'success'
                  :'error'"
                :tip="$t(item.isActive
                  ?'Сделать неактивным'
                  :'Сделать активным')"
                :disabled="innerLoading"
                @click="openConfirmationBeforChangeStatus(item.accountType,
                                                          item.bankAccountId,
                                                          !item.isActive)" />
            <icon-tip
                v-else
                icon="fiber_manual_record"
                :icon-color="item.isActive
                  ? 'success'
                  : 'error'"
                :tip="$t(item.isActive
                  ? 'Активный'
                  : 'Неактивный')" />
          </template>
          <template v-slot:item.bankAccountId="{ item }">
            <btn-icon-tip
                v-if="canEdit"
                :id="`editBtn-${item.bankAccountId}`"
                icon="edit"
                :disabled="innerLoading"
                :tip=" $t('Редактировать')"
                @click="openEditBankAccountDialog(item.accountType,
                                                  item.bankAccountId)" />
            <btn-icon-tip
                v-if="canDelete"
                :id="`deleteBtn-${item.bankAccountId}`"
                icon="delete_forever"
                :disabled="innerLoading"
                :tip=" $t('Удалить сведения о банковских реквизитах')"
                @click="openConfirmationBeforDelete(item.bankAccountId)" />
          </template>
        </v-data-table>
      </v-card> -->

      <v-card v-test="{ accounts: BANK_ACCOUNT_TYPES.CREDIT }" class="mt-3">
        <v-toolbar dark color="primary">
          <v-col cols="10">
            <v-toolbar-title class="textwithbackground--text">
              {{ $t('Счета в кредитной организации') }}
            </v-toolbar-title>
          </v-col>
          <v-col class="text-right" cols="2">
            <btn-icon-tip
                v-if="canCreate"
                id="addCreditOrgBankAccountBtn"
                icon="add"
                icon-color="secondaryiconbtn"
                :disabled="innerLoading"
                :tip="$t('Добавить сведения о банковских реквизитах')"
                @click="openAddBankAccountDialog(BANK_ACCOUNT_TYPES.CREDIT)" />
          </v-col>
        </v-toolbar>
        <v-divider />
        <v-data-table
            :headers="headers2"
            :items="creditAccounts"
            class="elevation-1"
            :items-per-page="itemsPerPage"
            item-key="bankAccountId"
            disable-sort-by
            :no-data-text="$t('Информация не добавлена')"
            :no-results-text="$t('Информация не добавлена')"
            :hide-default-footer="!creditAccounts.length"
            :locale="systemLocale">
          <template v-slot:top>
            <v-progress-linear :active="innerLoading" color="loader" indeterminate />
          </template>
          <!-- eslint-disable-next-line vue/valid-v-slot -->
          <template v-slot:item.bankName="{ item }">
            {{ item.bankName }}
          </template>
          <!-- eslint-disable-next-line vue/valid-v-slot -->
          <template v-slot:item.bik="{ item }">
            {{ item.bik }}
          </template>
          <!-- eslint-disable-next-line vue/valid-v-slot -->
          <template v-slot:item.correspondentAccount="{ item }">
            {{ item.correspondentAccount }}
          </template>
          <!-- eslint-disable-next-line vue/valid-v-slot -->
          <template v-slot:item.personalAccount="{ item }">
            {{ item.personalAccount }}
          </template>

          <!-- eslint-disable-next-line vue/valid-v-slot -->
          <template v-slot:item.isActive="{ item }">
            <btn-icon-tip
                v-if="canStatus"
                :id="`statusBtn-${item.bankAccountId}`"
                icon="fiber_manual_record"
                :icon-color="item.isActive
                  ?'success'
                  :'error'"
                :tip="$t(item.isActive
                  ?'Сделать неактивным'
                  :'Сделать активным')"
                :disabled="innerLoading"
                @click="openConfirmationBeforChangeStatus( item.accountType,
                                                           item.bankAccountId,
                                                           !item.isActive)" />
            <icon-tip
                v-else
                icon="fiber_manual_record"
                :icon-color="item.isActive
                  ? 'success'
                  : 'error'"
                :tip="$t(item.isActive
                  ? 'Активный'
                  : 'Неактивный')" />
          </template>
          <!-- eslint-disable-next-line vue/valid-v-slot -->
          <template v-slot:item.bankAccountId="{ item }">
            <btn-icon-tip
                v-if="canEdit"
                :id="`editBtn-${item.bankAccountId}`"
                icon="edit"
                :tip=" $t('Редактировать')"
                :disabled="innerLoading"
                @click="openEditBankAccountDialog( item.accountType,
                                                   item.bankAccountId)" />
            <btn-icon-tip
                v-if="canDelete"
                :id="`deleteBtn-${item.bankAccountId}`"
                icon="delete_forever"
                :tip=" $t('Удалить сведения о банковских реквизитах')"
                :disabled="innerLoading"
                @click="openConfirmationBeforDelete(item.bankAccountId)" />
          </template>
        </v-data-table>
      </v-card>
    </v-col>
    <v-col cols="12">
      <confirm-dialog
          v-if="confirmDialog.show"
          :dialog-prop="confirmDialog"
          @close="closeDialog('confirmDialog')" />
      <add-bank-account-dialog
          v-if="addBankAccountDialog.show"
          :dialog-prop="addBankAccountDialog"
          :create-bank-account="createBankAccount"
          @close="closeDialog('addBankAccountDialog')" />
      <edit-bank-account-dialog
          v-if="editBankAccountDialog.show"
          :dialog-prop="editBankAccountDialog"
          @close="closeDialog('editBankAccountDialog')" />
    </v-col>
  </v-row>
</template>

<script>

  import ConfirmDialog from '@/components/reused/common/ConfirmDialog.vue'
  import BtnIconTip from '@/components/reused/ui/BtnIconTip.vue'
  import IconTip from '@/components/reused/ui/IconTip.vue'
  import AddBankAccountDialog from './AddBankAccountDialog.vue'
  import EditBankAccountDialog from './EditBankAccountDialog.vue'
  import { BANK_ACCOUNT_TYPES } from '@/constants/business'

  export default {
    components: {
      ConfirmDialog,
      BtnIconTip,
      IconTip,
      AddBankAccountDialog,
      EditBankAccountDialog
    },
    props: {
      bankAccounts: {
        type: Array,
        default: function () {
          return []
        }
      },
      loading: {
        type: Boolean,
        default: false
      },
      canCreate: {
        type: Boolean,
        default: false
      },
      canEdit: {
        type: Boolean,
        default: false
      },
      canDelete: {
        type: Boolean,
        default: false
      },
      canStatus: {
        type: Boolean,
        default: false
      },
      showStatus: {
        type: Boolean,
        default: false
      },
      changeBankAccountStatus: {
        type: Function
      },
      createBankAccount: {
        type: Function
      },
      editBankAccount: {
        type: Function
      }
    },
    data () {
      return {
        BANK_ACCOUNT_TYPES,
        isLoading: false,
        itemsPerPage: 10,
        confirmDialog: {
          show: false,
          text: null,
          additional: null,
          callback: null,
          warning: true
        },
        addBankAccountDialog: {
          show: false,
          accountType: null,
          callback: null
        },
        editBankAccountDialog: {
          show: false,
          accountType: null,
          bankAccount: null,
          callback: null
        }
      }
    },
    computed: {
      // headers1 () {
      //   let headers = [
      //     { text: this.$t('Наименование получателя'), sortable: true, value: 'recipientName' },
      //     { text: this.$t('Отделение Банка России'), sortable: true, value: 'bankName' },
      //     { text: this.$t('Лицевой счет'), sortable: false, value: 'personalAccount' },
      //     { text: this.$t('КБК'), sortable: true, value: 'kbk' },
      //     { text: this.$t('ОКТМО'), sortable: true, value: 'oktmo' },
      //     { text: this.$t('Статус'), sortable: false, value: 'isActive' },
      //     { text: this.$t('Действия'), sortable: false, value: 'bankAccountId' }
      //   ]
      //   if (!this.isAdmin && !this.isRegistered) {
      //     headers = headers.filter(h => h.value !== 'isActive')
      //   }
      //   if (!this.canEdit && !this.canDelete) {
      //     headers = headers.filter(h => h.value !== 'bankAccountId')
      //   }
      //   if (!this.showStatus) {
      //     headers = headers.filter(h => h.value !== 'isActive')
      //   }
      //   return headers
      // },
      headers2 () {
        let headers = [
          { text: this.$t('Наименование кредитной  организации'), sortable: true, value: 'bankName' },
          { text: this.$t('БИК'), sortable: true, value: 'bik' },
          { text: this.$t('Корреспондентский счет'), sortable: false, value: 'correspondentAccount' },
          { text: this.$t('Расчетный счет'), sortable: true, value: 'personalAccount' },
          { text: this.$t('Статус'), sortable: false, value: 'isActive' },
          { text: this.$t('Действия'), sortable: false, value: 'bankAccountId' }
        ]
        if (!this.isAdmin && !this.isRegistered) {
          headers = headers.filter(h => h.value !== 'isActive')
        }
        if (!this.canEdit && !this.canDelete) {
          headers = headers.filter(h => h.value !== 'bankAccountId')
        }
        if (!this.showStatus) {
          headers = headers.filter(h => h.value !== 'isActive')
        }
        return headers
      },
      innerLoading () {
        return this.loading || this.isLoading
      },
      federalAccounts () {
        const list = this.bankAccounts || []
        return list.filter(item => item.accountType === BANK_ACCOUNT_TYPES.FEDERAL)
      },
      creditAccounts () {
        const list = this.bankAccounts || []
        return list.filter(item => item.accountType === BANK_ACCOUNT_TYPES.CREDIT)
      }
    },
    methods: {
      // показать окно подтверждения перед удалением
      openConfirmationBeforDelete: function (bankAccountId) {
        this.confirmDialog.additional = {
          bankAccountId
        }
        this.confirmDialog.text = this.$t('Информация по банковским реквизитам будет удалена. Продолжить?')
        this.confirmDialog.callback = this.deleteBankAccount
        this.confirmDialog.warning = true
        this.confirmDialog.show = true
      },
      openConfirmationBeforChangeStatus: function (accountType, bankAccountId, isActive) {
        this.confirmDialog.additional = {
          accountType,
          bankAccountId,
          isActive
        }
        this.confirmDialog.text = this.$t('Будет изменен статус счета. Продолжить?')
        this.confirmDialog.callback = this.changeBankAccountStatus
        this.confirmDialog.warning = true
        this.confirmDialog.show = true
      },
      // открыть окно создания счета
      openAddBankAccountDialog: function (accountType) {
        this.addBankAccountDialog.accountType = accountType
        this.addBankAccountDialog.callback = this.createBankAccount
        this.addBankAccountDialog.show = true
      },
      // открыть окно редактирования счета
      openEditBankAccountDialog: function (accountType, bankAccountId) {
        this.editBankAccountDialog.accountType = accountType
        this.editBankAccountDialog.callback = this.editBankAccount
        this.editBankAccountDialog.bankAccount = this.bankAccounts.find(ba => ba.bankAccountId === bankAccountId)
        this.editBankAccountDialog.show = true
      },
      deleteBankAccount: async function (model) {
        this.$emit('deleteBankAccount', { ...model })
      }
    }
  }
</script>
